// src/components/shell/help/modeHelpVersions.ts
// Per-mode help content versions. Bumping a value forces the help popover to
// auto-open on next visit (until the user dismisses it again).
//
// Convention: when you change a mode's help copy in modeHelpRegistry.tsx or in
// the underlying help/*Help.tsx component, increment that mode's version here.
// The "Don't show me this again" cache stores the last dismissed version per
// user×mode in localStorage (see useHelpDismissal.ts).
import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";

export const MODE_HELP_VERSION: Record<PrimaryMode, number> = {
  leads: 1,
  // `salesIntake` bumps the help version to 2 because the mode moved
  // buckets on 2026-06-15 (out of Manufacturing) and added the
  // role-scoped variant tabs. Users who dismissed the pre-move help
  // at version 1 see the popover auto-open once after the migration.
  salesIntake: 6,
  dealerPlaceOrder: 1,
  dealerOrderHistory: 1,
  // Opportunity Engine Phase 1 (2026-06-15) — first ship of the
  // Sales-bucket Opportunities mode. v1 baseline.
  opportunities: 2,
  salesConsole: 1,
  adsAssistant: 1,
  training: 1,
  trainingAuthor: 1,
  adsGuidance: 1,
  audienceData: 18,
  coverageAssistant: 1,
  // Documents Editor consolidation (2026-07-06).
  formsAndFormats: 7,
  aiPrompting: 1,
  locationTools: 1,
  knowledgebase: 1,
  admin: 1,
  dashboard: 1,
  operations: 4,
  dealTypes: 3,
  rtoTerms: 1,
  dailyChecklist: 1,
  physicalInventory: 1,
  opsLookup: 3,
  opsObligations: 2,
  dev: 1,
  platform: 1,
  mfgInventory: 12,
  mfgModels: 1,
  mfgPricing: 2,
  mfgOverhead: 1,
  mfgOrders: 1,
  mfgPlants: 4,
  mfgBuildPipeline: 6,
  mfgLaborBilling: 1,
  mfgFulfill: 2,
  mfgAudits: 1,
  mfgInventoryCount: 3,
  mfgPurchasing: 5,
  mfgLaborPay: 2,
  mfgBuilderAssistant: 1,
  mfgQcDashboard: 2,
  mfgReports: 1,
  mfgAdminHome: 1,
  logisticsRoutes: 1,
  logisticsCalendar: 1,
  logisticsCarriers: 1,
  fulfillmentInventory: 1,
  fulfillmentOrders: 1,
  fulfillmentIntake: 1,
  fulfillmentForms: 1,
  fulfillmentEntry: 1,
  serviceRequests: 1,
  serviceScheduling: 1,
  // Service setup card catalog + job types in Advanced (Slice 3, 2026-07-09).
  serviceDefinitions: 5,
  // Board dispatch-only cleanup (Slice 3, 2026-07-09).
  serviceBoard: 5,
  serviceMaterialsUsage: 1,
};

export function getModeHelpVersion(mode: PrimaryMode): number {
  return MODE_HELP_VERSION[mode] ?? 1;
}
